import React from 'react';
import { brandColors } from '../../config/theme';

const ModerationHistory = ({ listing }) => {
  const adminData = listing?.admin_data || {};
  const history = adminData.moderation_history || [];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getActionBadge = (actionType) => {
    switch (actionType?.toLowerCase()) {
      case 'approved':
        return (
          <span className="px-2 py-1 rounded text-xs font-medium bg-green-900/30 text-green-400 border border-green-700/50">
            ✓ {actionType}
          </span>
        );
      case 'rejected':
        return (
          <span className="px-2 py-1 rounded text-xs font-medium bg-red-900/30 text-red-400 border border-red-700/50">
            ✗ {actionType}
          </span>
        );
      case 'suspended':
        return (
          <span className="px-2 py-1 rounded text-xs font-medium bg-yellow-900/30 text-yellow-400 border border-yellow-700/50">
            ⏸️ {actionType}
          </span>
        );
      case 'pending':
        return (
          <span className="px-2 py-1 rounded text-xs font-medium bg-blue-900/30 text-blue-400 border border-blue-700/50">
            ⏳ {actionType}
          </span>
        );
      default:
        return (
          <span className="px-2 py-1 rounded text-xs font-medium bg-gray-700/50 text-gray-300 border border-gray-600/50">
            📝 {actionType || 'Moderation'}
          </span>
        );
    }
  };

  if (history.length === 0) {
    return (
      <div className="bg-gray-800 rounded-xl shadow-lg border border-gray-700 p-6">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center">
          <span className="mr-2 text-[#ff660e] text-xl">📜</span>
          Moderation History
        </h3>
        <div className="text-center py-6 border border-gray-700 rounded-lg">
          <div className="text-gray-400 text-4xl mb-3">📭</div>
          <p className="text-gray-500">No moderation history available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-800 rounded-xl shadow-lg border border-gray-700 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-white flex items-center gap-2">
          <span className="text-[#ff660e] text-xl">📜</span>
          <span>Moderation History</span>
        </h3>
        <div className="text-sm font-medium text-gray-300 bg-gray-700/50 px-3 py-1.5 rounded-lg border border-gray-600/50">
          {history.length} {history.length === 1 ? 'event' : 'events'}
        </div>
      </div>

      <div className="space-y-4">
        {history.map((event, index) => (
          <div 
            key={index} 
            className="border-l-4 pl-4 pb-4 relative group hover:bg-gray-750/50 rounded-lg -ml-2 pl-6 pt-2 transition-all duration-200"
            style={{ borderColor: brandColors.primary || '#ff660e' }}
          >
            {/* Timeline dot */}
            <div 
              className="absolute w-3 h-3 rounded-full -left-[6px] top-4 group-hover:scale-125 transition-transform"
              style={{ backgroundColor: brandColors.primary || '#ff660e' }}
            ></div>
            
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#ff660e]/20 to-orange-400/20 flex items-center justify-center text-gray-300">
                    📝
                  </div>
                  <div>
                    <div className="mb-1">
                      {getActionBadge(event.action_type)}
                    </div>
                    
                    {event.description && (
                      <p className="text-gray-300 text-sm mt-2">{event.description}</p>
                    )}
                    
                    {event.admin_username && (
                      <div className="flex items-center gap-2 text-sm text-gray-400 mt-2">
                        <span>By:</span>
                        <span className="font-medium text-white">{event.admin_username}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="md:text-right">
                <div className="text-xs text-gray-500 bg-gray-700/50 px-3 py-1.5 rounded-lg inline-block border border-gray-600/50">
                  {formatDate(event.created_at)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Summary */}
      <div className="mt-6 pt-4 border-t border-gray-700">
        <div className="flex items-center justify-between text-sm">
          <div className="text-gray-400">Latest action:</div>
          <div className="flex items-center gap-2">
            {history.length > 0 && getActionBadge(history[history.length - 1].action_type)}
            <span className="text-gray-300">
              {history.length > 0 && formatDate(history[history.length - 1].created_at)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModerationHistory;